import { render, staticRenderFns } from "./AssessmentAdditionalPaymentCallback.vue?vue&type=template&id=54c0c1f1&scoped=true"
import script from "./AssessmentAdditionalPaymentCallback.vue?vue&type=script&lang=js"
export * from "./AssessmentAdditionalPaymentCallback.vue?vue&type=script&lang=js"
import style0 from "./AssessmentAdditionalPaymentCallback.vue?vue&type=style&index=0&id=54c0c1f1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54c0c1f1",
  null
  
)

export default component.exports